import SectionHeading from "@/pages/home/components/SectionHeading";
import { latestAddressChannels } from "@/mocks/siteData";

const reliabilityStyles: Record<string, string> = {
  高: "bg-secondary-100 text-secondary-800",
  中高: "bg-accent-100 text-accent-800",
  中: "bg-background-200 text-foreground-700",
  低: "bg-primary-100 text-primary-700",
};

export default function LatestAddress() {
  return (
    <section id="latest" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="Latest Address"
          title="最新地址从哪里获取更可靠"
          desc="地址会调整，但获取地址的渠道相对稳定。下面列出五种常见渠道，并按可靠程度做了区分，建议优先使用排在前面的渠道。"
        />

        <div className="mt-10 rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
          <div className="hidden lg:grid grid-cols-12 gap-4 px-6 py-4 bg-background-100 border-b border-background-200 text-xs font-label tracking-widest uppercase text-foreground-500">
            <span className="col-span-3">获取渠道</span>
            <span className="col-span-5">如何操作</span>
            <span className="col-span-2">可靠程度</span>
            <span className="col-span-2">提示</span>
          </div>

          <div className="divide-y divide-background-200">
            {latestAddressChannels.map((channel) => (
              <div
                key={channel.name}
                className="grid grid-cols-1 lg:grid-cols-12 gap-3 lg:gap-4 px-5 md:px-6 py-5 hover:bg-background-100/70 transition-colors"
              >
                <div className="lg:col-span-3 flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className={`${channel.icon} text-lg`} />
                  </span>
                  <span className="font-heading font-bold text-foreground-950">
                    {channel.name}
                  </span>
                </div>
                <p className="lg:col-span-5 text-sm leading-relaxed text-foreground-600">
                  {channel.how}
                </p>
                <div className="lg:col-span-2">
                  <span
                    className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-label ${
                      reliabilityStyles[channel.reliability] ?? "bg-background-200 text-foreground-700"
                    }`}
                  >
                    可靠度 · {channel.reliability}
                  </span>
                </div>
                <p className="lg:col-span-2 text-xs md:text-sm text-foreground-500">
                  {channel.note}
                </p>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs md:text-sm text-foreground-500">
          <i className="ri-information-line mt-0.5" />
          不同渠道的更新速度与准确性存在差异，遇到信息冲突时，请以更正式、更稳定的渠道为准。
        </p>
      </div>
    </section>
  );
}